var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"images1-all"}},[(_vm.imageUrlArray.length > 0)?_c('div',{style:({
      'width': '100%',
      'border': '1px solid #00000055',
      'background-color': '#f6f6f6',
      'padding': '0.1rem 0.1rem',
      'margin-top': '1rem',
    })},[_c('transition-group',{style:({
        display: 'grid',
        'grid-template-columns': ("repeat(auto-fill, " + _vm.gridCellWidth + "%)"),
        'grid-template-rows': 'auto',
        'margin': '0 auto',
        width: '100%'
      }),attrs:{"tag":"div","name":'images-list-items'}},_vm._l((_vm.imageUrlArray),function(imageUrl,index){return _c('div',{key:_vm.imageKeyArray[index],style:({
          outline: _vm.$store.getters['multiInput/imageDataValid'](index)
            ? ((_vm.borderLineWidth(index)) + " solid " + (_vm.borderColor(index)))
            : null,
          margin: '3px',
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center'
        }),on:{"click":function($event){$event.stopPropagation();return _vm.imageClicked(index)},"drop":function($event){$event.preventDefault();return (function (e) { return _vm.dragDrop(e, index); })($event)},"dragover":function($event){$event.preventDefault();return (function () {})($event)},"dragend":function($event){$event.preventDefault();return (function () {})($event)},"dragenter":function($event){$event.preventDefault();return (function () {})($event)}}},[_c('div',{style:({
            padding: '0.3rem',
            'background-color': '#ffffff'
          })},[_c('div',{style:({
              position: 'relative'
            })},[_c('img',{ref:index + '',refInFor:true,staticClass:"transparent-pattern",style:({
                display: 'block',
                'max-width': '100%',
                'max-height': '100%',
                'width': 'auto',
                'height': 'auto'
              }),attrs:{"id":index + '',"src":imageUrl},on:{"dragstart":function (e) { return _vm.dragStart(e, index); },"dragover":function($event){$event.preventDefault();return (function () {})($event)},"dragend":function($event){$event.preventDefault();return (function () {})($event)}}}),_c('div',{style:({
                position: 'absolute',
                bottom: '0px',
                right: '0px',
                color: _vm.$vuetify.theme.primary,
                transform: 'translateY(0%) translateX(0%)',
                'background-color': _vm.$vuetify.theme.accent,
                padding: '0.1rem 0.3rem',
                margin: '0 0.2rem 0.2rem 0'
              })},[_c('strong',[_vm._v(_vm._s(index))])])])])])}),0)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }